import React from 'react';
import { AnimationArrow } from '../../AnimationArrow';

const ShowIcon = ({ agreement, isCollapse, collapsePreview }) => {
  if (agreement && !agreement.archived) {
    return (
      <div className="show-icon">
        {isCollapse ? (
          <AnimationArrow
            classNames="arrow-animation arrow-right"
            onClick={collapsePreview}
          />
        ) : (
          <AnimationArrow
            classNames="arrow-animation arrow-left"
            onClick={collapsePreview}
          />
        )}
      </div>
    );
  } else {
    return null;
  }
};

export default ShowIcon;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/ShowIcon.js